<template>
	<div
		class="modal fade wp_productReviewModalContainer"
		:id="'lightBoxWeb-review-'+index"
		role="dialog"
	>
		<div class="modal-dialog wp_productReviewModal">
			<!-- Modal content-->
			<div class="modal-content">
				<span
					class="close wp_closeModalBtn"
					data-dismiss="modal"
					data-test="reviewDesktopModalSpan"
					id="reviewDesktopModalSpan"
				>
						<svg
								xmlns:xlink="http://www.w3.org/1999/xlink"
								version="1.1"
								id="Capa_1"
								xmlns="http://www.w3.org/2000/svg"
								x="0px"
								y="0px"
								viewBox="0 0 612 612"
								style="enable-background:new 0 0 612 612;"
								xml:space="preserve"
								data-test="reviewDesktopModalSvg"
						>
							<g>
								<g id="cross">
									<g>
										<polygon points="612,36.004 576.521,
																		0.603 306,270.608 35.478,
																		0.603 0,36.004 270.522,
																		306.011 0,575.997 35.478,611.397
																		306,
																		341.411 576.521,611.397 612,575.997 341.459,
																		306.011">
										</polygon>
									</g>
								</g>
							</g>
						</svg>
				</span>
				<div class="modal-body wp_productReviewBody">
					<div class="row p-0 m-0">
						<div class="col-12 col-lg-7 wp_bgColorBlack">
							<!--&lt;!&ndash; mobile view top main slider &ndash;&gt;-->
							<!--<div class="wp_ItemsContainer wp_ReviewhideDesktop">-->
							<!--<div class="wp_swiperItemsContainer">-->
							<!--<swiper>-->
							<!--<swiper-item v-for="(url,index) in review.image_urls"-->
							<!--:key="'review-'+ index">-->
							<!--<img class :src="url">-->
							<!--</swiper-item>-->
							<!--</swiper>-->
							<!--</div>-->
							<!--</div>-->
							<!--&lt;!&ndash; mobile view top main slider &ndash;&gt;-->

							<!-- desktop view top main slider -->
							<div class="wp_ItemsContainer wp_ReviewhideMobile">
								<div class="owl-stage">
									<div class="owl-item wp_productReviewItems">
										<img
											class
											:src="review.image_urls[selectedImage]"
											alt="Selected Review Image"
											data-test="reviewDesktopModalReviewImg"
											id="reviewDesktopModalReviewImg"
										>
									</div>
								</div>
							</div>
							<!-- desktop view top main slider -->
							<!-- top main thumbs slider -->

							<div class="wp_reviewImageThumbContainer wp_ReviewhideMobile">
								<div class="owl-stage">
									<div
										class="owl-item wp_productReviewItems"
										v-for="(url,index) in review.image_urls"
										:key="'review-'+ index"
										@click.prevent="selectedImage = index"
										:data-test="'reviewDesktopModalSelectedReviewImgDiv'+index"
										:id="'reviewDesktopModalSelectedReviewImgDiv'+index"
									>
										<img
											class
											:src="url"
											alt="Selected Review Image"
											:data-test="'reviewDesktopModalSelectedReviewImg'+index"
											:id="'reviewDesktopModalSelectedReviewImg'+index"
										>
									</div>
								</div>
							</div>
							<!-- top main thumbs slider -->

						</div>
						<div class="col-12 col-lg-5 wp_bgColorWhite">
							<div class="wp_riviewRightSideContainer">
								<div
									class="wp_userRatingStarConatiner"
									:id="'review-rating-'"
								>
									<div class="wp_userRiviewPoint"
														data-test="reviewDesktopModalRating"
														id="reviewDesktopModalRating">
										{{review.rating}}
									</div>
									<svg
										xmlns:xlink="http://www.w3.org/1999/xlink"
										class="wp_RatingStarFill"
										version="1.1"
										id="Layer_1"
										xmlns="http://www.w3.org/2000/svg"
										x="0px"
										y="0px"
										viewBox="0 0 512 512"
										enable-background="new 0 0 512 512"
										xml:space="preserve"
										data-test="reviewDesktopModalRatingSvg"
									>
										<polygon points="255.999,19.827 314.622,200.247 504.327,
										200.247 350.853,311.754 409.472,492.174 255.999,
										380.668 102.525,492.174 161.146,311.754 7.673,
										200.247 197.378,200.247 ">
										</polygon>
									</svg>
								</div>
								<h5
									class="wp_ReviewCaptionH5"
									:id="'review-title-'"
									data-test="reviewDesktopModalReviewTitle"
								>
									{{review.review_title}}
								</h5>
								<!--<small>Updated 12.01.2018</small>-->
							</div>
							<div class="col-12 pr-0 mr-0 p-0">
								<p
									:id="'review-text-'+index"
									class="pl-3 pr-3"
									data-test="reviewDesktopModalReviewText"
								>
									{{review.review_text}}
								</p>
							</div>
							<div class="col-12 pr-0 mr-0">
								<div class="wp_riviewRightSideContainer">
									<review-footer
										:review="review"
										:productId="productId"
										:index="index"
										@commentReview="commentReview($event)"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReviewFooter from '../ReviewFooter'

export default {
	name: 'review-desktop-modal',
	props: {
		review: {},
		productId: null,
		index: {
			default: 0,
			type: Number
		}
	},
	components: {
		ReviewFooter
	},
	data () {
		return {
			selectedImage: 0
		}
	},
	methods: {
		commentReview (comment) {
			this.$emit('commentReview', comment)
		}
	}
}
</script>

<style scoped>

</style>
